import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { SelectItem } from 'primeng/primeng';

import { DataOperationUtil } from '../../../service/util/data-operation.util';
import { NecMultiSelectData } from './multi-select-data';
import { SelectedInfo } from './selected-info';

@Component({
  selector: 'nec-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})

export class NecMultiSelectComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() selectInfo: NecMultiSelectData;
  @Input() selectedValues: string[] = [];
  @Input() isInitEmit = true;
  @Input() showOptions = true;
  @Input() autoSize = false;
  @Input() showSelectAllItem = false;
  @Input() hideClear: boolean = false;
  @Output() selectedChange = new EventEmitter<SelectedInfo>();
  @Output() selectedClean = new EventEmitter<SelectedInfo>();

  // éé¡¹åå®¹
  labelContent: string;
  // ä¸æéé¡¹æ¯å¦æ¾ç¤º
  showMenu = false;

  oldSelectedItems: string[] = [];
  selectedItems: string[] = [];
  //é¤å¨é¨ä»¥å¤çææéé¡¹
  allItems: SelectItem[] = [];
  //å¨é¨æé®æ¯å¦è¢«éä¸­
  selectedAll: boolean = false;

  timer: any;

  width: number = 120;

  constructor(
    private el: ElementRef
  ) {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.autoSize) {
        this.width = this.el.nativeElement.parentElement.offsetWidth;
      }
    });
  }

  ngOnInit() {
    if (this.showSelectAllItem) {
      this.allItems = DataOperationUtil.deepCopy(this.selectInfo.selectItems);
      this.selectInfo.selectItems = [];
      let flag = true;
      this.allItems.forEach(item => {
        if (item.label === 'å¨é¨') {
          flag = false;
        }
      });
      if (flag) {
        this.selectInfo.selectItems.push({ label: 'å¨é¨', value: 'ALL' });
      }
      this.selectInfo.selectItems = this.selectInfo.selectItems.concat(this.allItems);
    }
    this.labelContent = this.selectInfo.defaultLabelContent;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedValues) {
      this.selectedValues = changes.selectedValues.currentValue;
      setTimeout(() => {
        this.selectedItems = this.selectedValues || [];
        if (this.selectedItems.length > 0) {
          this.refreshBox();
          if (this.isInitEmit) {
            this.selectedChange.emit({ selectedItems: this.selectedItems, changeItem: this.selectedItems[0] });
          }
        }
      });
    }
  }

  menuShowStateChange() {
    if (!!this.selectInfo.selectItems.length) {
      this.showMenu = !this.showMenu;
      if (this.showMenu) {
        // TODO: æ²¡æ¾å°ééççå¬æ¹å¼ï¼æç¨å®æ¶å¨ä»£æ¿
        setTimeout(() => {
          this.getBoundingClientRect();
        });
        this.timer = setInterval(() => {
          this.getBoundingClientRect();
        }, 100);
      } else {
        clearInterval(this.timer);
      }
    } else {
      this.showMenu = false;
      clearInterval(this.timer);
    }
  }

  getBoundingClientRect() {
    const dropdownMenuEle = this.el.nativeElement.querySelector('.drop-down-menu');
    if (!dropdownMenuEle) {
      return;
    }
    const boundingClientRect = this.el.nativeElement.querySelector('.multi-select-box').getBoundingClientRect() as DOMRect;
    dropdownMenuEle.style.top = boundingClientRect.y + boundingClientRect.height + 'px';
    dropdownMenuEle.style.left = boundingClientRect.x + 'px';
  }

  mouseLeaveBox() {
    this.showMenu = false;
    clearInterval(this.timer);
  }

  getShowTooltip(): string {
    return this.showOptions ? (this.labelContent ? this.labelContent : 'è¯·éæ©') : 'è¯·éæ©';
  }

  getShowContent(): string {
    if (this.showOptions) {
      if (this.selectInfo.defaultLabelHead) {
        return this.selectInfo.defaultLabelHead + 'ï¼' + this.labelContent;
      } else {
        return this.labelContent;
      }
    } else {
      return this.selectInfo.defaultLabelHead;
    }
  }

  selectItem(selectItem: SelectItem) {
    if (this.showSelectAllItem && selectItem.value === 'ALL') {
      this.selectedAll = !this.selectedAll;
      this.selectedItems = [];
      if (this.selectedAll) {
        this.allItems.forEach(item => {
          this.selectedItems.push(item.value)
        })
      }
    } else {
      if (DataOperationUtil.arrayIncludes(this.selectedItems, selectItem.value)) {
        this.selectedItems = this.selectedItems.filter(item => item !== selectItem.value);
      } else {
        this.selectedItems.push(selectItem.value);
      }
      if (this.showSelectAllItem) {
        this.selectedAll = this.checkAllSelected();
      }
    }
    this.refreshBox();
    this.selectedChange.emit({ selectedItems: this.selectedItems, changeItem: selectItem.value });
  }

  isSelected(item: SelectItem): boolean {
    if (this.showSelectAllItem && item.value === 'ALL') {
      return this.selectedAll;
    }
    return DataOperationUtil.arrayIncludes(this.selectedItems, item.value);
  }

  clearAll() {
    if (this.showSelectAllItem) {
      this.selectedAll = false;
    }
    this.selectedItems = [];
    this.refreshBox();
    this.selectedClean.emit({ selectedItems: this.selectedItems, changeItem: null });
  }

  private refreshBox() {
    this.oldSelectedItems = this.selectedItems.concat();
    let selectedLabels = this.selectInfo.selectItems
      .map(item => {
        if (DataOperationUtil.arrayIncludes(this.selectedItems, item.value)) {
          return item.label;
        }
      })
      .filter(item => !!item);
    this.labelContent = selectedLabels.length > 0 ? selectedLabels.join('ã') : this.selectInfo.defaultLabelContent;
  }

  private checkAllSelected() {
    return this.allItems.length === this.selectedItems.length;
  }
}
